import wl from './wl.definition';
import wlapi from './wlapi.definition';
import api from './api.definition';

export default {wl, wlapi, api};


// WEBPACK FOOTER //
// ./src/lib/blueprint.definition.js